import { render, staticRenderFns } from "./aGaoKao.vue?vue&type=template&id=af12ff70&scoped=true&"
import script from "./aGaoKao.vue?vue&type=script&lang=js&"
export * from "./aGaoKao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12ff70",
  null
  
)

export default component.exports